$ = require 'jquery'
Auth = require 'db/auth'
View = require 'view'
templates = require 'views/internal/templates'
PopOver = require 'views/lib/pop-over'
MemberMiniProfileView = require 'views/member-menu-profile/member-mini-profile-view'
trackUe = require 'debug/trackUe'

module.exports = class AboutThisBoardAdminListView extends View
  viewTitleKey: 'multi admin list'

  initialize: ->
    @listenTo @model

  render: ->
    data = @model.toJSON()

    @$el.html(
      templates.fill(
        'popover_about_this_board_admin_list',
        data
      )
    )

    @renderAdminList()

    @

  renderAdminList: ->
    $target = @$('.js-show-all-admins')
    visibleAdmins = @model.orderedVisibleAdmins()

    subviews = for admin in visibleAdmins
      @subview(MemberMiniProfileView, admin, { board: @model })
    @ensureSubviews(subviews, $target)



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/about-this-board-admin-list-view.coffee